export enum WorkflowType {
  Inbound = 'Inbound',
  Outbound = 'Outbound'
};
